
net.coruscation.cerulean.client.init();